export const version = "wallet/5.2.0";
//# sourceMappingURL=_version.js.map